import React from 'react';

import styles from './DisableBodyScroll.module.css';

export type Props = {

};

export const hooks = {
  useHandleBodyScroll() {
    React.useEffect(() => {
      document.body.classList.add(styles.bodyWithoutOverflowY);
      return () => document.body.classList.remove(styles.bodyWithoutOverflowY);
    }, []);
  },
};

export const DisableBodyScroll = React.memo(() => {
  hooks.useHandleBodyScroll();
  return null;
});

DisableBodyScroll.displayName = 'DisableBodyScroll';
